import { render, staticRenderFns } from "./UserAuthorisation.vue?vue&type=template&id=3c54162d&"
import script from "./UserAuthorisation.vue?vue&type=script&lang=js&"
export * from "./UserAuthorisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c54162d')) {
      api.createRecord('3c54162d', component.options)
    } else {
      api.reload('3c54162d', component.options)
    }
    module.hot.accept("./UserAuthorisation.vue?vue&type=template&id=3c54162d&", function () {
      api.rerender('3c54162d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/job-request/components/UserAuthorisation.vue"
export default component.exports